import { messages as portugueseMessages } from './pt';
import { messages as englishMessages } from './en';


export const messages = {
  ...portugueseMessages,
  ...englishMessages
};